import './App.scss';

import Home from './components/Home';
import Founder from './components/Founder';

import { useEffect } from 'react';
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
} from "react-router-dom";

// React Router keeps the old scroll offset across page changes — without this,
// clicking through to /founder from mid-page lands you partway down it. Hash
// links are left alone, since HashLink does its own scrolling.
function ScrollToTop() {
  const { pathname, hash } = useLocation()

  useEffect(() => {
    if (hash) return
    window.scrollTo(0, 0)
  }, [pathname, hash])

  return null
}

// Per-route <head>. index.html is a single static document served for every
// route by the firebase.json catch-all, so without this both URLs hand search
// engines the same title, the same description, and a canonical pointing at
// home — which would tell Google /founder is a duplicate and keep it out of
// the index entirely.
//
// The canonical exists at all because the site answers on both
// candlelyteproductions.com and the candlelyte-productions.web.app Firebase
// domain; those are two copies of one site competing with each other without it.
//
// Hand-rolled rather than react-helmet: two routes and three tags does not
// justify a dependency, and this runs in one effect with no reconciliation.
const CANONICAL_ORIGIN = "https://candlelyteproductions.com"

const ROUTE_META = {
  "/": {
    title: "Minneapolis Video Production | Candlelyte Productions",
    description:
      "Candlelyte Productions is a Minneapolis video production company telling parish, nonprofit, and brand stories through film — from script to final export.",
  },
  "/founder": {
    title: "Johnathan Geiger, Founder | Candlelyte Productions",
    description:
      "Johnathan Geiger directs, shoots, and edits for Candlelyte Productions — parish, nonprofit, and cause-led film based in Minneapolis and working across Minnesota.",
  },
}

function RouteMeta() {
  const { pathname } = useLocation()

  useEffect(() => {
    const meta = ROUTE_META[pathname]

    // An unknown path is the catch-all rewrite serving home for a URL that
    // isn't a real route. Leave the head on its index.html defaults rather
    // than describing it as something it isn't.
    if (!meta) return

    document.title = meta.title

    const description = document.querySelector('meta[name="description"]')
    if (description) description.setAttribute("content", meta.description)

    const canonical = document.querySelector('link[rel="canonical"]')
    // trailing slash on the root only, matching what sitemap.xml lists
    if (canonical) canonical.setAttribute("href", CANONICAL_ORIGIN + pathname)
  }, [pathname])

  return null
}

function App() {
  return (
    <Router className="App">
      <ScrollToTop />
      <RouteMeta />

      <Routes>
        <Route exact path="#home" element={<Home/>} />
        <Route exact path="/founder" element={<Founder/>} />
        <Route exact path="/" element={<Home/>}>
        </Route>
      </Routes>
    </Router>
  );
}

export default App;
